import React, { useState, useEffect, useContext, useRef } from 'react';
import { UserContext } from "../UserContext";
import PackDetails from '../AllPackDetails';
import { FaFileDownload, FaPlus, FaTimes } from "react-icons/fa";
import html2pdf from 'html2pdf.js';
import "./index.css";

const PackDetailsView = () => {
    const [operatorRole, setoperatorRole] = useState('');
    const [operatorId, setoperatorId] = useState('');
    const [operator, setOperator] = useState(null);
    const [packDetails, setPackDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedDuration, setSelectedDuration] = useState('All');
    const contentRef = useRef();
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [newPlan, setNewPlan] = useState({
        planName: '',
        plan: 'vrplay+ottplay',
        planCode: '',
        duration: '',
        planPrice: '',
        enable: 'yes',
        app_ids: [],
    });
    const [availableApps, setAvailableApps] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);

    const handleAddNewPlan = () => {
        setIsAddModalOpen(true);
        setIsEditing(false);
        setNewPlan({
            planName: '',
            plan: 'vrplay+ottplay',
            planCode: '',
            duration: '',
            planPrice: '',
            enable: 'yes',
            app_ids: []
        });
    };

    useEffect(() => {
        const role = "operator";
        const id = 89;
        
        setoperatorRole(role);
        setoperatorId(id);
    }, []);

    const fetchPackagesDynamically = async () => {       
        setLoading(true);
        try {
            const res = await fetch(`https://vrplay.in/portal_php/get_plans_with_apps_home.php`, {
                headers: {
                    Authorization: `Bearer VRPLAY`
                }
            });
            const data = await res.json();
            if (data.length > 0) setPackDetails(data);
        } catch (err) {
            // console.error('Fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchApps = async () => {
        try {
            const res = await fetch(`https://vrplay.in/portal_php/get_apps_home.php`, { 
                headers: {
                    Authorization: `Bearer VRPLAY`
                }
            });
            const data = await res.json();
            console.log(data);
            
            if (Array.isArray(data)) setAvailableApps(data);
        } catch (e) {
            // console.error("Failed to fetch apps", e);
        }
    };


    useEffect(() => {
        if (operatorId) {
            fetchPackagesDynamically();
            fetchApps();
        }
    }, [operatorId]);

    const toggleAddModal = () => {
        setIsAddModalOpen(!isAddModalOpen);
    };

    const toggleApp = (appId) => {
        setNewPlan(prev => {
            const alreadySelected = prev.app_ids.includes(appId);
            const app_ids = alreadySelected
                ? prev.app_ids.filter(id => id !== appId)
                : [...prev.app_ids, appId];

            return { ...prev, app_ids };
        });
    };

    const filteredPackages = selectedDuration === 'All'
        ? packDetails
        : packDetails.filter(pack => Number(pack.duration) === Number(selectedDuration));

    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
    const toggleMobileNav = () => {
        setIsMobileNavOpen(!isMobileNavOpen);
    };

    return (
        <>
        <header className="vrplay-header">
      <nav className="vrplay-nav h-container">
        <div className="vrplay-nav__brand">
          <div className="vrplay-logo">
            <span className="vrplay-logo__text">
              <img src="https://vrplay.in/images/vrplay1.png" alt="VRPlay" className="logo" />
            </span>
          </div>
        </div>
        
        <button 
          className={`vrplay-nav__toggle ${isMobileNavOpen ? 'active' : ''}`} 
          onClick={toggleMobileNav}
          id="navToggle"
        >
          <span className="vrplay-nav__toggle-line"></span>
          <span className="vrplay-nav__toggle-line"></span>
          <span className="vrplay-nav__toggle-line"></span>
        </button>
        
        <ul className={`vrplay-nav__menu ${isMobileNavOpen ? 'active' : ''}`} id="navMenu">
          <li className="vrplay-nav__item"><a href="/" className="vrplay-nav__link">Home</a></li>
          <li className="vrplay-nav__item"><a href="/" className="vrplay-nav__link">Live TV</a></li>
          <li className="vrplay-nav__item"><a href="/" className="vrplay-nav__link">OTT</a></li>
          <li className="vrplay-nav__item"><a href="/" className="vrplay-nav__link">Cloud PC</a></li>
          <li className="vrplay-nav__item"><a href="/" className="vrplay-nav__link">Automation</a></li>
          <li className="vrplay-nav__item"><a href="/" className="vrplay-nav__link">Security</a></li>
          <li className="vrplay-nav__item"><a href="/" className="vrplay-nav__link">Learning</a></li>
          <li className="vrplay-nav__item"><a href="/" className="vrplay-nav__link">Family Tracker</a></li>
          <li className="vrplay-nav__item"><a href="/all-packages" className="vrplay-nav__link">Packages</a></li>
          <li className="vrplay-nav__item"><a href="/login" className="vrplay-btn h-btn--primary h-nav__cta">Get Started</a></li>
        </ul>
      </nav>
    </header>
        

            <div className="pack-details-view-pack">
                <div className="header-section-pack">
                    <h1>Packages</h1>
                    <div className="header-actions-pack">
                        {operatorRole === "superadmin" && (
                            <button onClick={handleAddNewPlan} className="add-button-pack">
                                <FaPlus /> Add Plan
                            </button>
                        )}
                    </div>
                </div>

                <div className="filter-section-pack">
                    {['All', 30, 90, 180, 365].map(duration => (
                        <button
                            key={duration}
                            className={`filter-button-pack ${selectedDuration === duration ? 'active' : ''}`}
                            onClick={() => setSelectedDuration(duration)}
                        >
                            {duration === 'All' ? 'All Packages' : 
                             duration === 30 ? 'Monthly' :
                             duration === 90 ? 'Quarterly' :
                             duration === 180 ? 'Half Yearly' : 'Annual'}
                        </button>
                    ))}
                </div>

                {isAddModalOpen && (
                    <div className="modal-overlay-pack">
                        <div className="modal-content-pack">
                            <div className="modal-header-pack">
                                <h2>{isEditing ? 'Edit Plan' : 'Add New Plan'}</h2>
                                <button className="close-button-pack" onClick={toggleAddModal}>
                                    <FaTimes />
                                </button>
                            </div>
                            
                            <div className="form-grid-pack">
                                <div className="form-group-pack">
                                    <label>Plan Name *</label>
                                    <input 
                                        type="text" 
                                        placeholder="Enter plan name" 
                                        value={newPlan.planName}
                                        onChange={(e) => setNewPlan({ ...newPlan, planName: e.target.value })} 
                                    />
                                </div>
                                
                                <div className="form-group-pack">
                                    <label>Plan Type *</label>
                                    <input 
                                        type="text" 
                                        placeholder="e.g., vrplay+ottplay" 
                                        value={newPlan.plan}
                                        onChange={(e) => setNewPlan({ ...newPlan, plan: e.target.value })} 
                                    />
                                </div>
                                
                                <div className="form-group-pack">
                                    <label>Plan Code *</label>
                                    <input 
                                        type="text" 
                                        placeholder="Unique plan code" 
                                        value={newPlan.planCode}
                                        onChange={(e) => setNewPlan({ ...newPlan, planCode: e.target.value })} 
                                    />
                                </div>
                                
                                <div className="form-group-pack">
                                    <label>Duration (Days) *</label>
                                    <input 
                                        type="number" 
                                        placeholder="e.g., 30, 90, 180, 365" 
                                        value={newPlan.duration}
                                        onChange={(e) => setNewPlan({ ...newPlan, duration: e.target.value })} 
                                    />
                                </div>
                                
                                <div className="form-group-pack">
                                    <label>Price (₹) *</label>
                                    <input 
                                        type="number" 
                                        placeholder="Plan price" 
                                        value={newPlan.planPrice}
                                        onChange={(e) => setNewPlan({ ...newPlan, planPrice: e.target.value })} 
                                    />
                                </div>
                                
                                <div className="form-group-pack">
                                    <label>Status *</label>
                                    <select 
                                        value={newPlan.enable} 
                                        onChange={(e) => setNewPlan({ ...newPlan, enable: e.target.value })}
                                    >
                                        <option value="yes">Active</option>
                                        <option value="no">Inactive</option>
                                    </select>
                                </div>
                            </div>

                            <div className="apps-section-pack">
                                <label>Select Apps:</label>
                                <div className="app-grid-pack">
                                    {availableApps.map(app => (
                                        <div
                                            key={app.id}
                                            className={`app-card-pack ${newPlan.app_ids.includes(app.id) ? 'selected' : ''}`}
                                            onClick={() => toggleApp(app.id)}
                                        >
                                            <img 
                                                src={`https://vrplay.in/images/${app.name.toLowerCase()}.png`} 
                                                alt={app.name} 
                                                className='ott-image-pack' 
                                                onError={(e) => {
                                                    e.target.src = 'https://via.placeholder.com/50x50?text=App';
                                                }}
                                            />
                                            <span>{app.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            
                            <div className="modal-actions-pack">
                                <button 
                                    className="cancel-button-pack" 
                                    onClick={toggleAddModal}
                                    disabled={saveLoading}
                                >
                                    Cancel
                                </button>
                                <button 
                                    className="save-button-pack" 
                                    disabled={saveLoading}
                                >
                                    {saveLoading ? 'Saving...' : 'Save Plan'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {loading ? (
                    <div className="packages-loading-container">
                        <div className="packages-skeleton-loader">
                            {[...Array(6)].map((_, index) => (
                                <div key={index} className="package-skeleton-card">
                                    <div className="skeleton-package-header">
                                        <div className="skeleton-package-name"></div>
                                        <div className="skeleton-edit-btn"></div>
                                    </div>
                                    <div className="skeleton-package-duration"></div>
                                    <div className="skeleton-package-price"></div>
                                    <div className="skeleton-ott-container">
                                        {[...Array(4)].map((_, ottIndex) => (
                                            <div key={ottIndex} className="skeleton-ott-item"></div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : filteredPackages.length === 0 ? (
                    <div className="no-packages-found">
                        <h2>No Packages Found</h2>
                        <p>Try selecting a different duration filter or add a new plan.</p>
                    </div>
                ) : (
                    <div ref={contentRef} className="package-view-container-pack">
                        <div className='pack-grid-pack'>
                            {filteredPackages.map(pack => {
                                const modifiedPack = {
                                    ...pack,
                                    planPrice: pack.planPrice,
                                    showBlankPrice: false
                                };

                                return (
                                    <div className='pack-item-pack' key={pack.id}>
                                        <PackDetails
                                            {...modifiedPack}
                                            onEdit={() => {
                                                const matchedAppIds = availableApps
                                                    .filter(app => pack.ott?.includes(app.name))
                                                    .map(app => app.id);

                                                setNewPlan({
                                                    id: pack.id,
                                                    planName: pack.planName,
                                                    plan: pack.plan,
                                                    planCode: pack.planCode,
                                                    duration: pack.duration,
                                                    planPrice: pack.planPrice, // Original price without operator markup
                                                    enable: pack.enable,
                                                    app_ids: matchedAppIds,
                                                });

                                                setIsAddModalOpen(true);
                                                setIsEditing(true);
                                            }}
                                            canEdit={operatorRole === "superadmin"}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default PackDetailsView;